import axios from "axios";

export type ApiErrorType =
  | "notFound"
  | "forbidden"
  | "network"
  | "server"
  | "unknown";

const SERVER_ERROR_STATUSES = new Set<number>([500, 502, 503, 504]);

const NETWORK_ERROR_CODES = new Set<string>([
  "ERR_NETWORK",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ENETUNREACH",
  "ENOTFOUND",
]);

export const getApiErrorType = (error: unknown): ApiErrorType => {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return "network";
  }

  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 404) return "notFound";
    if (status === 403) return "forbidden";
    if (status !== undefined && SERVER_ERROR_STATUSES.has(status)) {
      return "server";
    }

    if (error.code && NETWORK_ERROR_CODES.has(error.code)) {
      return "network";
    }

    if (error.message?.toLowerCase().includes("timeout")) {
      return "network";
    }
  }

  return "unknown";
};
